import { useCurrency } from "./use-currency";

export function useStringCurrency() {
	const { formatCurrency: formatCurrencyOfValue } = useCurrency(undefined, {
		centsBase: false,
	});
	const { formatCurrency: formatCurrencyOfCost } = useCurrency(undefined, {
		centsBase: false,
		minimumFractionDigits: 4,
	});

	return {
		formatCurrencyOfValue: (value: string) => formatCurrencyOfValue(Number(value)),
		formatCurrencyOfCost: (value: string) => formatCurrencyOfCost(Number(value)),
	};
}
